import { convertTextToUrl } from '../convertTextToUrl';

export const filesNames = ({ brand, name }: { brand?: string; name?: string }) => {
    if (!name) return;

    return convertTextToUrl(`${brand || 'noname'}-${name}`);
};

export const filesNameSimple = (name: string) => {
    if (!name) return;

    return convertTextToUrl(name);
};
